module.exports = __webpack_public_path__ + "img/thinking_panda3.1622242b.gif";